// TechDebt: https://jira.ets.mpi-internal.com/browse/MTR-105739
// This will soon be in sui-js package
// part of the code extracted from. https://github.com/epeli/underscore.string/blob/master/cleanDiacritics.js
const from = 'ąàáäâãåæăćčĉęèéëêĝĥìíïîĵłľńňòóöőôõðøśșşšŝťțţŭùúüűûñÿýçżźž'
const to = 'aaaaaaaaaccceeeeeghiiiijllnnoooooooossssstttuuuuuunyyczzz'.split('')

function replaceCharIfNeeded(char) {
  const index = from.indexOf(char)
  return index === -1 ? char : to[index]
}

export function transformToKebabCase(str, allowQueryParams) {
  const validCharsRegEx = allowQueryParams
    ? /[^a-z0-9\\. \- _ ? =]/g // only letters numbers, dahses, low dashes, dots, equals and question marks
    : /[^a-z0-9\\. \- _]/g // only letters numbers, dahses, low dashes and dots

  return str
    .toLowerCase()
    .replace(/.{1}/g, replaceCharIfNeeded)
    .replace(validCharsRegEx, '') // remove invalid chars
    .replace(/\s/g, '_') // collapse whitespace and replace by _
}

export const getImageSizeFromUrl = ({url}) => {
  // example urls:
  //    img1: https://a.ccdn.es/cnet/contents/media/resources/2023/3/1311467.jpg/0_0_1280_720/
  //    img2: https://a.ccdn.es/cnet/contents/media/skoda/superb/1302400.jpg
  // For img1: we need to get width and height from the last parameters
  // For img2 and yams: need to find a way to get them in https://jira.ets.mpi-internal.com/browse/MTR-67917
  const sizeRegex = /(\d+)_(\d+)\//
  const regexResult = url.match(sizeRegex)
  const hasMatches = Boolean(regexResult && regexResult.length)

  return hasMatches
    ? {
        width: regexResult[1],
        height: regexResult[2]
      }
    : {}
}
